import { CheckIcon } from '@heroicons/react/20/solid';
import { PencilIcon } from '@heroicons/react/24/outline';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function SelectionMultiSelectListItemWithDescription(props) {
  const {
    label,
    description,
    selected = false,
    disabled = false,
    onChange = () => {},
    onAction = () => {},
    actionLabel = null,
    selectedMessage = null,
  } = props;
  function handleClick() {
    if (!disabled) onChange(!selected);
  }

  function handleKeyDown(e) {
    if (e.key === ' ' && !disabled) {
      e.preventDefault();
      onChange(!selected);
    }
  }

  function handleActionClick(e) {
    e.stopPropagation();
    if (!disabled) onAction();
  }

  const messageRemainder = actionLabel && selectedMessage?.startsWith(actionLabel)
    ? selectedMessage.slice(actionLabel.length)
    : selectedMessage;

  return (
    <div
      role="checkbox"
      aria-checked={selected}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : 0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={classNames(
        'flex flex-col gap-[10px] px-6 py-4 rounded-[10px] w-full border border-gray-300 bg-white',
        'outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2',
        'hover:bg-orange-50 active:bg-orange-100',
        disabled ? 'opacity-40 cursor-not-allowed pointer-events-none' : 'cursor-pointer',
      )}
    >
      <div className="flex flex-row gap-2 items-start">
        <div className="py-1 shrink-0">
          <div
            className={classNames(
              'flex items-center justify-center rounded-[4px] size-[22px]',
              selected ? 'bg-cs-orange-500' : 'bg-white border border-gray-300',
            )}
            aria-hidden="true"
          >
            {selected && <CheckIcon className="size-5 text-white" />}
          </div>
        </div>

        <div className="flex flex-col gap-0.5 flex-1 min-w-0">
          <span className="font-normal text-base leading-[1.5] text-gray-800">
            {label}
          </span>
          {selected && description && (
            <span className="font-normal text-sm leading-[1.4] text-gray-500">
              {description}
            </span>
          )}
        </div>
      </div>

      {selected && selectedMessage && (
        <div className="bg-orange-200/26 border border-cs-yellow-400 rounded-[10px] p-[10px] flex gap-[10px] items-center"
             onClick={handleActionClick} role="button"
        >
          <PencilIcon className="size-4 text-gray-800 shrink-0" aria-hidden="true" />
          <p className="font-normal text-sm leading-[1.5] text-gray-800">
            {`${messageRemainder} `}
            {actionLabel && (
              <span
                className="text-cs-blue-500 underline font-normal focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-1 rounded"
              >
                {` ${actionLabel}`}
              </span>
            )}
          </p>
        </div>
      )}
    </div>
  );
}

SelectionMultiSelectListItemWithDescription.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onAction: PropTypes.func,
  actionLabel: PropTypes.string,
  selectedMessage: PropTypes.string,
};
